import { useState } from "react"

/**
 * Collapsible category component with content.
 * Renders an expandable/collapsible category with title, toggle icon, and list of items.
 * @param {Object} props
 * @param {string} props.title - Category title
 * @param {Array} props.items - Items to display in the category
 * @param {string} props.categoryId - Unique category identifier
 * @returns {JSX.Element}
 */
export default function CollapsibleCategory({ title, items, categoryId }) {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <div className="shortwaysCategory">
      <div className="categoryTitle" aria-controls={categoryId} aria-expanded={isOpen} style={{ cursor: "pointer" }} onClick={() => setIsOpen(!isOpen)}>
        {title}
        <span className={`listToggleIcon ${isOpen ? "open" : ""}`} data-testid="listToggleIcon" />
      </div>
      {isOpen && (
        <div id={categoryId} className="collapse show">
          <div className="shortwaysCategory">
            {items.map((item, index) => (
              <div key={index}>
                <div className="categoryLine">
                  <span className="itemName">{item}</span>
                </div>
                {index < items.length - 1 && <div className="itemSeparator" data-testid="itemSeparator" />}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  )
}
